import { mergeQueryKeys } from '@lukemorales/query-key-factory'

import { memberAttributes } from './memberAttributes.keys'
import { richmenus } from './richmenus.keys'
import { settings } from './settings.keys'

export * from './coupons.queries'
export * from './members.queries'
export * from './memberAttributes.queries'
export * from './richmenus.queries'
export * from './settings.queries'

export const queries = mergeQueryKeys(richmenus, settings, memberAttributes)
